import React, {useCallback, useState} from 'react';

import {AdminRoleSelect} from 'src/admin-rights-service/modules/admin-profile/sections/admin-role-select';
import {useRolesPermissions} from 'src/admin-rights-service/modules/roles-page/useRolesPermissions';
import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';
import {WidthItem} from 'src/components/width-item';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';


import {ROLE_MODAL_TITLES} from '../constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {BulkUpdateAdminRoleRequest} from 'src/openapi/admin/models/BulkUpdateAdminRoleRequest';
import type {ProfileRecord} from 'src/openapi/admin/models/ProfileRecord';

type Props = {
    userIds: number[],
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<BulkUpdateAdminRoleRequest>,
};

const MODAL_WIDTH = 450;

export const AssignToRoleModal = ({userIds, onCloseModal, processAction}: Props) => {
    const [selectedRole, setSelectedRole] = useState<ProfileRecord | null>(null);
    const {isLoading: isRolesPermissionsLoading, data: roles} = useRolesPermissions();

    const updateGroup = useCallback(async (options?: ActionOptions) => {
        if (selectedRole) {
            return await processAction({
                usersIds: userIds,
                newRoleId: selectedRole.profileId,
            }, options);
        }
    }, [selectedRole, userIds, processAction]);

    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {ROLE_MODAL_TITLES.ASSIGN}
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: MODAL_WIDTH}}>
                <Group direction="v">
                    <WidthItem width="100%">
                        {pluralize('Assign the selected user[s] to a role', userIds.length)}
                    </WidthItem>
                    <WidthItem width="100%">
                        <AdminRoleSelect
                            isLoading={isRolesPermissionsLoading}
                            role={selectedRole}
                            roles={roles}
                            changeRole={setSelectedRole}
                        />
                    </WidthItem>
                </Group>
            </DialogMain>
            <BulkActionFooter action="Update" onConfirm={updateGroup} disabled={!selectedRole}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
